import React from 'react';
import { motion } from 'framer-motion';

const HandwrittenChecklist = ({ items, delay = 0 }) => (
  <div className="space-y-2">
    {items.map((item, i) => (
      <motion.div
        key={i}
        initial={{ opacity: 0, x: -8 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.35, delay: delay + i * 0.1 }}
        className="flex items-start gap-2"
      >
        <span className={`mt-0.5 flex-shrink-0 text-lg leading-none ${item.done ? 'text-[#3D7A5E]' : 'text-[#9E9690]'}`}>
          {item.done ? '✓' : '○'}
        </span>
        <span className={`text-base leading-snug ${item.done ? 'line-through text-[#9E9690]' : 'text-[#1A1A18]'}`}
          style={{ textDecorationColor: '#9E9690' }}>
          {item.text}
        </span>
      </motion.div>
    ))}
  </div>
);

export default HandwrittenChecklist;